import type { FC } from 'react'
import { CwsGrid, CwsGridCol, CwsGridRow, CwsInput, CwsP } from '@components/cws'
import type { CustomerInfo } from '@hooks/useReturnOrders'
import type { Dispatch, SetStateAction } from 'react'
import { useMemo } from 'react'
import { accountNumberSchema } from '@utils/validations/returnOrder'
import { useTranslate } from '@hooks/useTranslation'

interface BankDetailsProps {
  customerInfo?: CustomerInfo
  setCustomerInfo: Dispatch<SetStateAction<CustomerInfo>>
}

export const BankDetails: FC<BankDetailsProps> = ({ customerInfo, setCustomerInfo }) => {
  const { translate } = useTranslate()

  const handleChangeBankName = (value: string) => {
    setCustomerInfo((prevState) => ({ ...prevState, bankName: value }))
  }

  const handleChangeIban = (value: string) => {
    setCustomerInfo((prevState) => ({ ...prevState, iban: value }))
  }

  const isIbanValid = useMemo(() => accountNumberSchema.isValidSync(customerInfo?.iban), [customerInfo?.iban])

  return (
    <CwsGrid>
      <CwsGridRow>
        <CwsGridCol col="12" className="cws-px-0 cws-py-0">
          <CwsGridRow>
            <CwsGridCol col={12} lg={6}>
              <CwsP size="small">{translate('return.form.refund.bank')}:</CwsP>
              <CwsInput onChange={handleChangeBankName} value={customerInfo?.bankName} />
            </CwsGridCol>
            <CwsGridCol col={12} lg={6}>
              <CwsP size="small">{translate('return.form.refund.iban')}:</CwsP>
              <CwsInput onChange={handleChangeIban} value={customerInfo?.iban} />
            </CwsGridCol>
          </CwsGridRow>
        </CwsGridCol>
      </CwsGridRow>
    </CwsGrid>
  )
}

export default BankDetails
